/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/


/*
TERMINOLOGY

Any SUPERVISOR is SERVICE PROVIDER (used to believe it was a supervisor of nurses)
Any DOCTOR is SUPERVISING PROVIDER
*/

import Card from "./Card";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import LoadingAlert from "./LoadingAlert";
import Alert from "./Alert";
import DocumentList from "./DocumentList";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import CommentList from "./CommentList";
import ProductList from "./ProductList";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Examination from "./Examination";
import Icon from "./Icon";
import { SidebarGlobal } from "./_SidebarGlobal";
import { Pop } from "./PopModal";
import { Link } from "react-router-dom";
import { Dropdown, DropdownButton, Modal } from "react-bootstrap";
import FormInput from "./FormInput";
import Tick from "./Tick";
import React from "react";
import AppActions from "./AppActions";
import SignatureModal from "./SignatureModal";
import { v4 as uuidv4 } from 'uuid';
import RequestFormList from "./requestform/RequestFormList";
import { PDFModalGlobal } from "./PDFModal";
import SharedUtil from "../shared/SharedUtil";
import CPTCodeSelect from "./CPTCodeSelect";
import VisitBaseCom from "./visit/VisitBaseCom";
import Workflow from "./workflow/Workflow";
import L from "./Lang";

class VisitView extends VisitBaseCom {

    constructor(props) {
        super(props);
        this.load = this.load.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            loaded: false,
            submitting: false,
            item: {},
            examination: {},
            examinationObj: {},
            visit: { wounds: [] },
            edit: true,
            editVisit: false,
            tab: props.params.tab ?? 'summary',
            visitInfo: {},
            typeList: [],
            note: {},
            hashState: uuidv4(),
            latestNote: null,
            latestMedicalHx: null,
            latestWoundHx: null
        }
        this.notesRef = React.createRef();
        this.load = this.load.bind(this);
        this.loadOrder = this.loadOrder.bind(this);
        this.loadVisitTypes = this.loadVisitTypes.bind(this);
        this.loadNote = this.loadNote.bind(this);
        this.onSaveWound = this.onSaveWound.bind(this);
        this.cancel = this.cancel.bind(this);
        this.removeWound = this.removeWound.bind(this);
        this.claim = this.claim.bind(this);
        this.reschedule = this.reschedule.bind(this);
        this.reassign = this.reassign.bind(this);
        this.submitVisitType = this.submitVisitType.bind(this);
    }

    async componentDidMount() {
        await this.getSettings();
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        this.load();
        qreq.get('/api/user/list?showDisabled=false', j => {
            if (j.list)
                this.setState({ users: j.list });
        });
        await this.loadWorkflows();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }


    claim() {
        Pop.showConfirm('Are you sure you want to set this encounter as visited (by You)?', 'Visited Encounter', () => {
            qreq.post('/api/visit/claim', { ...this.state.visit }, j => {
                if (j.errorCode === 0) {
                    this.success('You have set this encounter as visited (by You).');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    load() {
        qreq.get('/api/visit/get/' + this.props.params.id, j => {
            if (j.item) {
                try {
                    j.item.examination = { ...JSON.parse(j.item.examinationJsonData), id: 0 };
                    this.setState({ examination: { ...j.item, id: 0 }, examinationObj: j.item.examinationObj });
                }
                catch (e) {
                    console.log('JSON parse error: ', e);
                }
                this.setState({ visit: j.item });
                this.loadVisitTypes(j.item);
                this.loadNote(j.item);
                if (j.item.isEncounter)
                    this.loadOrder(j.item.orderID);
                else
                    this.setState({ loaded: true });
            }
            else if (j.errorCode) {
                this.alert(j.errorMessage);
                this.setState({ loaded: true });
            }
        }, () => {
            this.alert('Unknown error ocurred.');
        });
    }

    loadOrder(id) {
        qreq.get('/api/order/get/' + id + '?allowLead=true', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else {
                Globals.processResultObject(j, ['lotNumber']);
                this.setState({ item: j.item });
            }
            this.setState({ loaded: true });
        }, () => {
            this.alert('Unknown error ocurred.');
        });
    }

    loadVisitTypes(visit) {
        qreq.get('/api/visit/type/list?isEncounter=' + (visit.isEncounter ? 'true' : 'false'), j => {
            if (j.list) {
                this.setState({ typeList: j.list, placementType: j.list.find(a => a.name === 'Placement') });
            }
        });
    }

    loadNote(visit) {
        qreq.get('/api/visit/note?visitID=' + visit.id, j => {
            if (j.item)
                this.setState({ note: j.item, latestNote: j.item.note });
        });
    }

    onSubmit(e) {
        e.preventDefault();

    }

    onSaveWound(obj) {

    }

    cancel(e) {
        e?.preventDefault();
        qreq.post('/api/visit/cancel?id=' + this.state.visit.id, { canceledReason: this.state.visit.canceledReason }, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else
                this.props.navigate('/calendar');
        }, this.unkownErrorCallback);
    }

    remove = () => { // visit
        Pop.showConfirm('Are you sure you want to remove this encounter?', 'Remove Encounter', () => {
            qreq.post('/api/visit/remove?id=' + this.state.visit.id, {}, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else
                    this.props.navigate('/calendar');
            }, this.unkownErrorCallback);
        });
    }

    removeWound(obj) {
        qreq.post('/api/wound/visit/remove', obj, j => {
            if (j.errorCode === 0)
                this.load();
            else
                this.alert(j.errorMessage);
        });
    }

    reschedule(e) {
        if (e) e.preventDefault();
        qreq.post('/api/visit/reschedule', { ...this.state.visit, ...this.state.visitInfo, products: [] }, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.errorCode === 0) {
                this.setState({ showReschedule: false });
                this.success('Visit has been re-scheduled.');
                this.load();
            }
            else
                this.unkownErrorCallback();
        }, this.unkownErrorCallback);
    }

    reassign(e) {
        if (e) e.preventDefault();
        var visitInfo = { ...this.state.visit, ...this.state.visitInfo, products: [] };
        if (!visitInfo.assignedToUserID)
            visitInfo.assignedToUserID = 0;
        qreq.post('/api/visit/reassign', visitInfo, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.errorCode === 0) {
                this.setState({ showReassign: false });
                this.success('Visit has been reassigned.');
                this.load();
            }
            else
                this.unkownErrorCallback();
        }, this.unkownErrorCallback);
    }

    submitVisitType(e) {
        if (e) e.preventDefault();
        qreq.post('/api/visit/update-visit-type', { id: this.state.visit.id, selectedVisitTypesJsonData: JSON.stringify(this.state.selectedVisitTypes) }, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.errorCode === 0) {
                this.setState({ showEditVisitType: false });
                this.success('Visit type has been updated.');
                this.load();
            }
            else
                this.unkownErrorCallback();
        }, this.unkownErrorCallback);
    }

    onNotesChange = (v, propName) => {
        if (Auth.hasRole('readonly')) return;
        if (!propName)
            propName = 'note';
        this.setState({ note: { ...this.state.note, [propName]: v }, touched: true });
    }

    onNotesTick = () => {
        if (Auth.hasRole('readonly')) return;
        if (this.state.ammend) return;
        if (!this.state.touched) return;
        if (

            (this.state.note?.note !== undefined && this.state.note.note !== null) ||
            (this.state.note?.medicalHx !== undefined && this.state.note.medicalHx !== null) ||
            (this.state.note?.woundHx !== undefined && this.state.note.woundHx !== null)
        ) {
            if (this.blankValue(this.state.note.note) !== this.blankValue(this.state.latestNote)
                || this.blankValue(this.state.note.medicalHx) !== this.blankValue(this.state.latestMedicalHx)
                || this.blankValue(this.state.note.woundHx) !== this.blankValue(this.state.latestWoundHx)
            ) {
                this.saveNotes();
            }
        }
    }

    saveNotes = () => {
        this.setState({ latestNote: this.state.note.note, latestMedicalHx: this.state.note.medicalHx, latestWoundHx: this.state.note.woundHx, savingNote: true });
        qreq.post('/api/visit/note/save', { visitID: this.state.visit.id, note: this.state.note.note, notesHeightOffset: this.notesRef.current.offsetHeight, medicalHx: this.state.note.medicalHx, woundHx: this.state.note.woundHx }, j => {
            if (j.errorCode) {
                if (j.errorCode === 9) {
                    this.showConfirmClaim(this.saveNotes);
                }
                else if (j.errorCode !== 7)
                    this.alert(j.errorMessage);
                this.setState({ savingNote: false });
            }
            else
                this.setState({ savingNote: false });
        }, this.unkownErrorCallback);
    }


    showSign = (type) => {
        this.setState({ showSign: true, signType: type });
    }


    sign = (data) => {
        if (this.state.signType === 'DOCTOR' || this.state.signType === 'SUPERVISOR') {
            this.setState({ signing: <p><Icon icon="faLock" /> <span><L>Please wait as visit becomes locked...</L></span></p> });
            qreq.post('/api/visit/sign', { visitID: this.state.visit.id, orderID: this.state.visit.orderID, signature: data.signature, signatureType: this.state.signType, base64Signature: data }, j => {
                if (j.errorCode === 0) {
                    this.success('Signature saved.');
                    this.setState({ showSign: false, ammend: false });
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
                this.setState({ signing: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ signing: false });
            });
        }
        else
            this.alert('Unknown signature type.');
    }

    requestSign = (type) => {
        var displayType = type === 'DOCTOR' ? 'SUPERVISING PROVIDER' : 'SERVICE PROVIDER';
        Pop.showConfirm(<>An email will be sent to the {displayType} for signature. Are you sure?</>, 'Request Signature', () => {
            qreq.post('/api/visit/sign/request', { visitID: this.state.visit.id, orderID: this.state.visit.orderID, signatureType: type }, j => {
                if (j.errorCode === 0) {
                    this.success('Signature request sent.');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    downloadProgressReport = () => {
        SharedUtil.downloadProgressReport(this.state.item.id, this.state.visit.id);
    }

    previewProgressReport = async () => {
        try {
            let available = await SharedUtil.progressReportAvailableAsync(this.state.item.id, this.state.visit.id);
            if (!available) {
                this.alert('Progress report is not available yet.');
                return;
            }
            PDFModalGlobal.show(
                Globals.serverUrl + '/api/report/wound/status/pdf/' + this.state.item.id + '/' + this.state.visit.id + '/progress-report-' + this.state.item.id + '.pdf'
                , this.downloadProgressReport
            );
        }
        catch (e) {
            this.unkownErrorCallback();
        }

    }

    ammend = () => {
        this.setState({ originalVisit: { ...this.state.visit }, visit: { ...this.state.visit, locked: false }, ammend: true });
    }

    ammendCommit = () => {
        if (this.state.timeTouched)
            this._updateTime(this.state.timeTouched);
        if (this.state.cptCodesTouched)
            this._updateCPTCodes(this.state.cptCodesTouched);
        qreq.post('/api/visit/note/save', { ...this.state.note, visitID: this.state.visit.id, ammend: true }, j => {
            if (j.errorCode === 0) {
                this.success('Changes have been committed.');
                this.setState({ ammend: false, hashState: uuidv4(), note: j.item });
                this.load();
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    ammendCancel = () => {
        this.setState({ ammend: false });
        this.load();
    }

    unlock = () => {
        Pop.showConfirm(<L>Are you sure you want to unlock visit?</L>, <L>Unlock</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/visit/unlock', { id: this.state.visit.id });
                if (j.errorCode === 0) {
                    this.success('Unlocked visit!');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    examinationSaved = () => {
        this.ammendCancel();
    }

    onVisitTypeChange = () => {
        this.setState({ selectedVisitTypes: { ...this.state.selectedVisitTypes } });
    }

    updateTime = (v) => {
        if (!this.state.ammend)
            this._updateTime(v);
        else
            this.setState({ timeTouched: v });
    }

    _updateTime = async (v) => {
        try {
            let j = qreq.postAsync('/api/visit/time/update', { id: this.state.visit.id, duration: v });
            if (j.errorCode === 0)
                this.success('Time has been updated.');
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    updateCPTCodes = () => {
        if (!this.state.ammend)
            this._updateCPTCodes(this.state.visit.cptCodes);
        else
            this.setState({ cptCodesTouched: [...this.state.visit.cptCodes] });
    }

    _updateCPTCodes = async (cptCodes) => {
        try {
            let j = qreq.postAsync('/api/visit/cpt/update', { id: this.state.visit.id, cptCodes: cptCodes });
            if (j.errorCode === 0)
                this.success('CPT codes have been updated.');
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    isPast = () => {
        try {
            return new Date(this.state.visit.scheduleDate) < new Date();
        }
        catch (e) {
            return false;
        }
    }

    workflows = () => {
        var list = [];
        this.state.workflows?.forEach(i => {
            list.push(<Tab eventKey={'workflow-' + i.id} title={<><Icon icon="faArrowsTurnToDots" className="d-none d-md-inline-block" /> {i.name}</>}>
                <Workflow
                    visit={this.state.visit}
                    order={this.state.item}
                    struct={i}
                    onSave={() => this.load()}
                    locked={this.state.visit.locked}
                    ammend={this.state.ammend}
                />
            </Tab>);
        })
        return list;
    }

    loadWorkflows = async () => {
        await this.fillListAsync('/api/workflow/list', 'workflows');
    }

    showLegacyExamination = () => {
        /*
        let dt = new Date();
        if(dt > new Date(Date.parse('2025-06-01')))
            return false;
        */
        return this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0;
    }

    render() {
        const header = <h1><L>Visit</L></h1>;

        const durations = [
            { id: 20, name: '20 minutes' },
            { id: 30, name: '30 minutes' },
            { id: 45, name: '45 minutes' },
            { id: 60, name: '1 hour' },
            { id: 120, name: '2 hours' },
            { id: -1, name: '>2 hours' },
        ];

        if (!this.state.loaded)
            return <div className="container-fluid">{header}<LoadingAlert /></div>;

        if (!this.state.visit)
            return null;


        // old mark as visited code
        /*
            {this.state.visit && !this.state.visit.claimed && !this.state.visit.locked && !Auth.hasRole('readonly') && <button type="button" className="btn btn-success" onClick={this.claim}>
                <Icon icon="faStar" /> <span className="d-none d-lg-inline"><L>Mark Visited</L></span>
            </button>}

        */

        SidebarGlobal.setSubNav(<div className="btn-group">
            {!this.state.visit?.isSignedBySupervisor
                && <div title={this.state.visit.assignedToUserID === this.state.user?.id ? 'Sign this visit.' : 'Only the assigned supervisor can sign the visit.'}>
                    <button type="button" className="btn btn-success" onClick={() => this.showSign('SUPERVISOR')} disabled={this.state.visit.assignedToUserID !== this.state.user?.id}>
                        <Icon icon="faSignature" /> <L>Sign</L></button>
                </div>}
        </div>);

        const shared = <>
            {this.state.showCancel && <Modal show={this.state.showCancel} onHide={() => this.setState({ showCancel: false })}>
                <Modal.Header closeButton><L>Cancel</L></Modal.Header>
                <form onSubmit={this.cancel}>
                    <Modal.Body>
                        <FormInput model={this.state.visit} name="canceledReason" label="Why is this event being canceled?" type="textarea" required />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-danger"><L>Submit Cancellation</L></button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showCancel: false })}>Close</button>
                    </Modal.Footer>
                </form>
            </Modal>}
            {this.state.showClaim && <Modal show={this.state.showClaim} onHide={() => this.setState({ showClaim: false })}>
                <Modal.Header closeButton><L>Claim</L></Modal.Header>
                <form onSubmit={this.claim}>
                    <Modal.Body>
                        <FormInput model={this.state.visitInfo} name="startTime" label="Start Time" type="time" required />
                        <FormInput model={this.state.visitInfo} name="endTime" label="End Time" type="time" required />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success"><L>Claim</L></button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showClaim: false })}><L>Cancel</L></button>
                    </Modal.Footer>
                </form>
            </Modal>}
            {this.state.showReschedule && <Modal show={this.state.showReschedule} onHide={() => this.setState({ showReschedule: false })}>
                <Modal.Header closeButton><L>Reschedule</L></Modal.Header>
                <form onSubmit={this.reschedule}>
                    <Modal.Body>
                        <FormInput model={this.state.visitInfo} name="scheduleDate" label="New Schedule Date" type="date" dateAllowTime={true} required />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success"><L>Reschedule</L></button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showReschedule: false })}><L>Cancel</L></button>
                    </Modal.Footer>
                </form>
            </Modal>}
            {this.state.showReassign && <Modal show={this.state.showReassign} onHide={() => this.setState({ showReassign: false })}>
                <Modal.Header closeButton><L>Reassign</L></Modal.Header>
                <form onSubmit={this.reassign}>
                    <Modal.Body>
                        <FormInput model={this.state.visitInfo} name="assignedToUserID" label="Assigned To" type="select" options={this.state.users} selectDefault="Not Assigned" groupBy="roleGroupName" />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success"><L>Reassign</L></button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showReassign: false })}><L>Cancel</L></button>
                    </Modal.Footer>
                </form>
            </Modal>}
            {this.state.showEditVisitType && <Modal show={this.state.showEditVisitType} onHide={() => this.setState({ showEditVisitType: false })}>
                <Modal.Header closeButton><L>Edit Visit Type</L></Modal.Header>
                <form onSubmit={this.submitVisitType}>
                    <Modal.Body>
                        {this.state.typeList.map(i => <div key={i.id}>
                            <FormInput model={this.state.selectedVisitTypes} name={i.id} type="switch" label={i.name} onChange={this.onVisitTypeChange} />
                        </div>)}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showEditVisitType: false })}><L>Cancel</L></button>
                    </Modal.Footer>
                </form>
            </Modal>}
        </>;

        if (!this.state.visit.isEncounter) {
            return <div className="container-fluid VisitView">
                {shared}
                <h1>{this.state.visit.eventName}</h1>
                <div className="app-actions">
                    <div className="text-start flex-fill">
                        <button type="button" className="btn btn-secondary btn-lg" onClick={this.goBack}><L>Go Back</L></button>
                    </div>
                </div>
                <h5 className="mb-3"><span className="text-muted">Event date:</span> {Globals.toMDYHMLocalDateString(new Date(this.state.visit.scheduleDate))}</h5>
                <Card title="Event Details">
                    <p>{this.state.visit.description ?? 'None'}</p>
                </Card>
            </div>;
        }


        if (!this.state.visit.id || !this.state.item.id)
            return <Alert message="Visit not found." icon="ExclamationCirlce" type="danger" />;

        return <div className="container-fluid VisitView">
            <div className="p-4"></div>
            {shared}
            <h1 className="d-flex">
                <div>{this.state.item?.patient?.initials}</div>
                <div className="text-secondary"> {Globals.toMDYHMLocalDateString(new Date(this.state.visit.scheduleDate))}</div>
                <div className="flex-fill text-end">#{this.state.visit?.id}</div>
            </h1>

            <SignatureModal
                title={this.state.signType === 'DOCTOR' ? 'SUPERVISING PROVIDER' : 'SERVICE PROVIDER'}
                show={this.state.showSign}
                signing={this.state.signing}
                onHide={() => this.setState({ showSign: false })}
                onSave={this.sign} />

            <AppActions noBack={this.state.ammend}>
                {this.state.ammend ? <>
                    <div className="d-flex">
                        <div>
                            <button type="button" className="btn btn-secondary btn-lg" onClick={this.ammendCancel}><L>Cancel</L></button>
                        </div>
                        <div className="flex-fill">
                            <button type="button" className="btn btn-success btn-lg" onClick={this.ammendCommit}><Icon icon="faSave" /> <L>Commit</L></button>
                        </div>
                    </div>
                </> : <DropdownButton title="Actions" size="lg" drop="up" className="has-icons">
                    {!this.state.visit?.isSignedBySupervisor && this.state.visit.assignedToUserID === this.state.user?.id && <Dropdown.Item onClick={() => this.showSign('SUPERVISOR')}>
                        <Icon icon="faSignature" /> Sign (Provider)
                    </Dropdown.Item>}
                    {!this.state.visit?.isSignedByDoctor && this.state.item.providerID === this.state.user?.providerID && <Dropdown.Item onClick={() => this.showSign('DOCTOR')}>
                        <Icon icon="faSignature" /> Sign (Supervising Provider)
                    </Dropdown.Item>}
                    <Dropdown.Item onClick={this.downloadProgressReport}><Icon icon="faFilePdf" /> <L>Export Progress Report</L></Dropdown.Item>
                    {Auth.hasRole('medical') && <Dropdown.Item onClick={() => this.setState({ showClaim: true })}><Icon icon="faStar" /> <L>Mark as Visited</L></Dropdown.Item>}
                    {Auth.hasRole('manager') && this.state.visit && (!this.state.visit.claimed || !this.isPast()) && <Dropdown.Item onClick={() => this.setState({ showReschedule: true })}><Icon icon="faCalendarDay" /> <L>Reschedule</L></Dropdown.Item>}
                    {Auth.hasRole('visit-manager') && this.state.visit && (!this.state.visit.claimed || !this.isPast()) && <Dropdown.Item onClick={() => this.setState({ showReassign: true })}><Icon icon="faUserPen" /> <L>Reassign</L></Dropdown.Item>}
                    {Auth.hasRole('manager') && this.state.visit?.locked && <Dropdown.Item onClick={this.ammend}><Icon icon="faEdit" /> <L>Ammend</L></Dropdown.Item>}
                    {Auth.hasRole('manager') && <Dropdown.Item onClick={() => this.setState({ showCancel: true })}><Icon icon="faCancel" /> <L>Cancel</L></Dropdown.Item>}
                    {Auth.hasRole('manager') && this.state.visit?.locked && this.state.user?.id === this.state.visit?.assignedToUserID && <Dropdown.Item onClick={this.unlock}><Icon icon="faLockOpen" /> <L>Unlock</L></Dropdown.Item>}
                    {Auth.hasRole('manager') && <Dropdown.Item onClick={this.remove}><Icon icon="faTrash" /> <L>Remove</L></Dropdown.Item>}
                </DropdownButton>}
            </AppActions>

            {this.state.visit?.canceled && <Card title="Canceled">
                <p className="lead">{this.state.visit.canceledReason ?? <i><L>No reason was input.</L></i>}</p>
            </Card>}



            <Tabs
                activeKey={this.state.tab}
                defaultActiveKey={this.state.tab}
                onSelect={(k) => { this.setState({ tab: k }); this.props.navigate('/visit/view/' + this.state.visit.id + '/' + k, { replace: true }); }}
                id="c-visit-tabs"
                className="app-tabs"
                animation="false">
                <Tab eventKey="summary" title={<><Icon icon="faRectangleList" className="d-none d-md-inline-block" /> <L>Summary</L></>}>

                    <Card title={this.state.visit.isEncounter ? 'Encounter' : 'Event'} headerButtons={this.props.orderID && Auth.hasRole('account-manager') ? <Link to={'/order/view/' + this.props.orderID} role="button" className="btn btn-primary"><Icon icon="faHospitalUser" /> <L>View Patient</L></Link> : null}>
                        <table className="table table-bordered fs-6">
                            <tbody>
                                <tr>
                                    <th>Patient:</th>
                                    <td><Link to={'/order/view/' + this.state.visit.orderID}>{this.state.item.patient.name}</Link></td>
                                </tr>
                                {this.state.visit.visitType.id ? <tr><th>For:</th><td><span className="ms-3 badge bg-secondary">{this.state.visit.visitType.name}</span></td></tr> : ''}
                                {this.state.visit.selectedVisitTypes && this.state.visit.selectedVisitTypes.length !== 0 ? <tr><th>For:</th><td>{this.state.visit.selectedVisitTypes.map(i => <span key={i.id} className="ms-3 badge bg-secondary">{i.name}</span>)}
                                    {!Auth.hasRole('readonly') && <button type="button" className="btn btn-primary btn-sm ms-3" onClick={() => this.setState({ selectedVisitTypes: JSON.parse(this.state.visit.selectedVisitTypesJsonData), showEditVisitType: true })}><Icon icon="faPencil" /> <L>Edit</L></button>}
                                </td></tr> : ''}


                                {/* SERVICE PROVIDER */}
                                {this.state.visit.assignedToUserName ? <tr><th>Service Provider:</th><td>
                                    <span>{this.state.visit.assignedToUserName}</span>
                                    <span className="ms-md-3 d-block d-md-inline-block">
                                        {!Auth.hasRole('readonly') && (this.state.visit.isSignedBySupervisor ? <span><span className="text-success"><L>SIGNED</L></span> <span className="text-muted">
                                            on {Globals.toMDYHMLocalDateString(this.state.visit.supervisorSignature?.signatureDate)}</span></span> :
                                            this.state.visit.assignedToUserID === this.state.user?.id ? <button type="button" className="btn btn-success" onClick={() => this.showSign('SUPERVISOR')}>
                                                <Icon icon="faSignature" /> <L>Sign</L></button>
                                                : <button type="button" className="btn btn-primary" onClick={() => this.requestSign('SUPERVISOR')}>Request Signature</button>)}
                                    </span>
                                </td></tr> : ''}
                                {this.state.visit.claimedByUserName ? <tr><th>Service Provider:</th><td>{this.state.visit.claimedByUserName}</td></tr> : ''}

                                {/* SUPERVISING PROVIDER */}
                                {(this.state.item.provider?.fullName && this.state.item.provider.fullName !== this.state.visit.assignedToUserName) ? <tr><th>Supervising Provider:</th><td>
                                    <span>{this.state.item.provider.fullName}</span>
                                    <span className="ms-md-3 d-block d-md-inline-block">
                                        {!Auth.hasRole('readonly') && (this.state.visit.isSignedByDoctor ? <span><span className="text-success"><L>SIGNED</L></span> <span className="text-muted">
                                            on {Globals.toMDYHMLocalDateString(this.state.visit.doctorSignature?.signatureDate)}</span></span> :
                                            this.state.item.providerID === this.state.user?.providerID ? <button type="button" className="btn btn-success" onClick={() => this.showSign('DOCTOR')}>
                                                <Icon icon="faSignature" /> <L>Sign</L></button>
                                                : <button type="button" className="btn btn-primary" onClick={() => this.requestSign('DOCTOR')}>Request Signature</button>)}
                                    </span>
                                </td></tr> : ''}



                            </tbody>
                        </table>
                    </Card>


                    <div className="mb-3">

                        <div className="row">
                            <div className="col-md">
                                <Card title="Time">
                                    <FormInput model={this.state.visit}
                                        name="duration"
                                        label="Duration"
                                        type="select"
                                        options={durations}
                                        disabled={this.state.visit.locked || Auth.hasRole('readonly')}
                                        onChange={this.updateTime}
                                    />
                                </Card>
                            </div>
                            <div className="col-md">
                                <CPTCodeSelect
                                    item={this.state.visit}
                                    disabled={this.state.visit.locked || Auth.hasRole('readonly')}
                                    onChange={this.updateCPTCodes}
                                    hideModifiers
                                />
                            </div>
                        </div>

                        <Card title={this.state.visit.isEncounter ? 'Encounter Notes' : 'Event Notes'}>
                            <Tick onTick={this.onNotesTick} interval={3000} />
                            <FormInput
                                model={this.state.note}
                                name="note"
                                label="Write notes here..."
                                type="textarea"
                                rows={12}
                                onChange={this.onNotesChange}
                                labelAsPlaceholder
                                inputRef={this.notesRef}
                                disabled={this.state.visit.locked || Auth.hasRole('readonly')}
                                ai
                            />
                            {this.state.visit.isEncounter && <div className="row">
                                <div className="col-md">
                                    <FormInput model={this.state.note} name="medicalHx" label="Medical Hx"
                                        type="textarea" rows={5} onChange={v => this.onNotesChange(v, 'medicalHx')}
                                        disabled={this.state.visit.locked || Auth.hasRole('readonly')} ai />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.note} name="woundHx" label="Wound Hx"
                                        type="textarea" rows={5} onChange={v => this.onNotesChange(v, 'woundHx')}
                                        disabled={this.state.visit.locked || Auth.hasRole('readonly')} ai />
                                </div>
                            </div>}
                            {!this.state.visit.locked && !this.state.ammend && ((this.state.note?.note && this.state.note.note !== this.state.latestNote) || this.state.savingNote ? <div className="text-info"><L>Saving changes...</L></div> : <div className="text-secondary"><L>Notes are up to date</L></div>)}
                        </Card>



                    </div>
                    {!Auth.hasRole('external') && <div className="mb-3">
                        <CommentList visitId={this.state.visit.id} hash={this.state.hashState} />
                    </div>}
                </Tab>
                {this.workflows()}
                {this.showLegacyExamination() && <Tab eventKey="examination" title={<><Icon icon="faStethoscope" className="d-none d-md-inline-block" /> <L>Legacy&nbsp;Exam</L></>}>
                    <Examination
                        item={this.state.examination}
                        examination={this.state.examinationObj}
                        visit={this.state.visit}
                        onVisitUpdate={v => this.setState({ visit: v })}
                        tab="chronic"
                        disabled={this.state.visit.locked || Auth.hasRole('readonly')}
                        onSave={this.examinationSaved}
                    />
                </Tab>}
                {false && <Tab eventKey="products" title={<><Icon icon="faBox" className="d-none d-md-inline-block" /> <L>Products</L></>}>
                    <ProductList visit={this.state.visit} />
                </Tab>}
                <Tab eventKey="documents" title={<><Icon icon="faFile" className="d-none d-md-inline-block" /> <L>Documents</L></>}>
                    {this.state.tab === 'documents' && <DocumentList list={this.state.visit.documents} parentItem={this.state.item} parentVisit={this.state.visit} edit={this.state.edit} />}
                    <RequestFormList item={this.state.item} />
                </Tab>
            </Tabs>
        </div>;
    }

}

export default withParamsAndNavigate(VisitView);